export default __webpack_public_path__ + "static/media/uber.b7fd374b.png";